"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlyoutMenu = exports.FlyoutContent = exports.FlyoutContentContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const style_1 = __importDefault(require("style"));
const Menu_1 = require("./Menu");
exports.FlyoutContentContainer = styled_components_1.default.div `
  z-index: ${style_1.default.Depth.Position.F0};
  position: absolute;
  left: 0px;
  top: 100%;
  margin-top: ${style_1.default.Sizing.Size.Micro};
  width: 100%;
`;
const FlyoutContent = (_a) => {
    var { content } = _a, rest = __rest(_a, ["content"]);
    return ((0, jsx_runtime_1.jsx)(exports.FlyoutContentContainer, { children: content(rest) }));
};
exports.FlyoutContent = FlyoutContent;
const FlyoutMenu = (props) => {
    const { content } = props;
    return ((0, jsx_runtime_1.jsx)(Menu_1.Menu, Object.assign({}, props, { content: (props) => {
            return ((0, jsx_runtime_1.jsx)(exports.FlyoutContent, Object.assign({}, props, { content: content })));
        } })));
};
exports.FlyoutMenu = FlyoutMenu;
